// Every signed-in page. Signed out → /sign-in; signed in but not through onboarding → /welcome.
// The sync engine for the reader's highlights, notes, bookmarks, places and shelf runs here, one per
// account (src/sync/): on the API it syncs; on the prototype it keeps everything in this browser.
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { API_URL, apiBase } from "../api/client";
import { AppShell } from "../components/AppShell";
import { keys, useConfig, useSession } from "../data/queries";
import { SyncProvider } from "../sync/react";

export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    const session = await context.queryClient.ensureQueryData({ queryKey: keys.session, queryFn: () => context.source.session() });
    if (!session) throw redirect({ to: "/sign-in", search: { next: location.href } });
    if (!session.onboarded) throw redirect({ to: "/welcome" });
  },
  component: Signed,
});

function Signed() {
  const { data: session } = useSession();
  const { data: config } = useConfig();
  const id = session?.user.id ?? null;
  // The `sync` switch: missing or off means this browser keeps everything locally until it opens.
  const state = config?.features?.sync?.state;
  const online = !!API_URL && (state === "on" || state === "maintenance");
  return (
    <SyncProvider account={id ? (API_URL ? id : `prototype-${id}`) : null} baseUrl={online ? apiBase() : null}>
      <AppShell>
        <Outlet />
      </AppShell>
    </SyncProvider>
  );
}
